module.exports = __webpack_public_path__ + "img/Disaster-7.c0caa90a.jpg";